import React, { useEffect, useState } from "react";
import './Subscription.scss'
import Terms from "../commonComponents/Terms";
import Footer2 from "../commonComponents/Footer2";
import langIcon from "../assets/icons/language_icon.png"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import config, { getHeaders } from "../config";
import { useLanguage } from "../Context/LangContext";
import { reactLocalStorage } from "reactjs-localstorage";
import Sorry from "../commonComponents/Sorry";
import { SendGuiDataEvents } from "../CommonSript";
import logo from "../assets/icons/logo.png";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const FillOtp = (props)=>{
    const [lang, setLang] = useState(localStorage.getItem("lang") ? localStorage.getItem("lang") : "en");
    const homeLogo = props.homeLogo
    const banners = props.banners
    const [loading,setLoading]=useState(false);
    const [otp, setOtp] = useState(new Array(4).fill(""))
    const history = useHistory();
    const cta_selector=localStorage.getItem("selector")
    const {sourceFile,setSourceFile}=useLanguage();
    const [count,setCount]=useState(3);
    const [otpAtmptMsg,setOtpAtmptMsg]=useState(false);
    const [attempts,setAttempts]=useState(0);
    const pack=reactLocalStorage.get("packType");
    const msisdn = reactLocalStorage.get("msisdn") || reactLocalStorage.get("tempMsisdn");
    const fraudToken = reactLocalStorage.get("fraudToken"); // Retrieve fraud token
    const  page  = sessionStorage.getItem('page')

    const [openSorry,setOpenSorry]=useState(false)
    const {ip}=useLanguage();
    useEffect(() => {
      const handlePopState = (event) => {
        event.preventDefault();
        history.go(1);
      };
  
      window.addEventListener('popstate', handlePopState);
  
      history.push(history.location.pathname);
  
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }, [history]);
    useEffect(() => {
      const script = document.createElement('script');
      script.text = sourceFile;
      script.defer = true;
      document.head.appendChild(script);
      var ev = new Event('DCBProtectRun')
      document.dispatchEvent(ev);
      return () => {
        document.head.removeChild(script);
      }
    }
    
  , [sourceFile]);

  useEffect(() => {
    let guiDataEvents = {};
    guiDataEvents["page"] = "otp";
    guiDataEvents["event"] = "open";
    SendGuiDataEvents(guiDataEvents);
  }, []);

//   useEffect(() => {
//     const script = document.createElement("script"); // Fraud Prevention Script
//     script.src = "http://dcb.kuwait.zain.digitalabs.ae:8016/antifraud/d513e9e03227.js";
//     script.async = true;
//     document.head.appendChild(script);

//     script.onload = () => {
//         const ids = { 
//             form: 'otp_form', 
//             confirm_button: 'otp_submit_btn', 
//             pin_input: 'pin_input' 
//         };
//         const partner = 'partner:h7j9w4n8-97a4-4eb7-9ec1-4333131805cb';
//         const service = 'campaign:2a73f22ed63c1f8e40925632b7n10w6fed611779';
        
//         const detector = new window.Detector(ids, partner, service, fraudToken, {});
//         detector.setup();
//     };
//     return () => document.head.removeChild(script);
// }, []); // End Fraud Prevention Script

    const isFilled = (value) => value !== '';
    const matchOtp = () => {
      let guiDataEvents = {};
      guiDataEvents["page"] = "otp";
      guiDataEvents["event"] = "otp_request";
      SendGuiDataEvents(guiDataEvents);
      if(otp?.length===4){
        console.log("inside func")
      setLoading(true)
      const url = `${config.get('base')}${config.get('pinSubmit')}`;
      const otpString = otp?.join("");
      const headers={
          ...getHeaders(),
          // Language:lang
      }
      const body = {
        'msisdn': msisdn,
        "pin":otpString,
        "token":page=='login'? '' : fraudToken,
    }
      fetch(url, {
          method: 'POST',
          body: JSON.stringify(body),
          headers: headers
      })
          .then(res => {
              if (!res.ok) { throw res }
              return res.json()
          })
          .then((result) => {
            const otpStatus = result?.status
              console.log('result message::', result);
              let guiDataEvents = {};
                guiDataEvents["page"] = "subscription";
                guiDataEvents["event"] = "otp_response";
                guiDataEvents["status"] = otpStatus;
                SendGuiDataEvents(guiDataEvents);
                if( localStorage.getItem("campId")==="C2CSMPMSC2C")
                  {
                    reactLocalStorage.set("injectScript",'true')
                  }
              if(result?.status==="success")
                  {   
                    history.push(`/?msisdn=${msisdn}`)   
                  // window.location.replace(result?.content_link)
                }
                else if(result?.status==="failed" && result?.count>=1)
                  {
                    setCount(result?.count);
                    setAttempts(prev=>prev+1);
                    setOtpAtmptMsg(true);
                    setLoading(false);
                  }
               else
               {
                  console.log("something went wrong")
                  reactLocalStorage.set("modal","failure")
                  setLoading(false);
                  history.push({
                      pathname: "/info",
                      state: { status: "failure" }
                  }                    
                  )
              }
          },
              (error) => {
                  console.log('error:::', error)
                  setLoading(false);
              })
            }
  }
    const handleChange = (element, index) => {
        const enteredValue = element.value;
        if (isNaN(element.value)) return false;
    
        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))])
    
        if (enteredValue === "") {
          // Move focus to the previous field when deleting the value
          if (element.previousSibling) {
            element.previousSibling.focus();
          }
        } else if (element.nextSibling) {
          // Move focus to the next field when filling the value
          element.nextSibling.focus();
        }
    
      };

    const toggleLanguage = () => {
        const newLang = lang === "en" ? "ar" : "en";
        setLang(newLang);
        localStorage.setItem("lang", newLang);
    };

    const goToSorry=()=>{
      console.log("sorry clicked")
      let guiDataEvents = {};
      guiDataEvents["page"] = "otp";
      guiDataEvents["event"] = "exitButton_clicked";
      SendGuiDataEvents(guiDataEvents);
      setOpenSorry(true)
      setSourceFile("")
    }

    useEffect(() => {
      setLoading(false)
        const storedLang = localStorage.getItem("lang" ) ? localStorage.getItem("lang" ) : "ar" ;
        if (storedLang) {
            setLang(storedLang);
            localStorage.setItem("lang", storedLang);
        }
        return ()=>
          {
            setSourceFile("")
          }
    }, []);

    const isOtpFilled = otp.every(isFilled);
    if(openSorry) return < Sorry handleSorry={setOpenSorry}/>;

    return(
      <>
        {loading?<div className="loader-container">
      <div className="lds" ></div>
      </div> :
        <div className="container" style={{whiteSpace:"break-spaces"}}>
           <div className={`stripe ${lang === "ar" ? "rtl" : ""}`}>{lang === "en" ? "Free for 24 hours then AED 2.10/ day or AED 11/ week (VAT inclusion)" : "مجانا لمدة 24 ساعة من 2.10 درهم إماراتي / يومياً  أو 11 درهم إماراتي / أسبوعياً  (شامل ضريبة القيمة المضافة) "} </div>
            <div className="images">
                <img 
                className="logosub"
                alt="logo"
                src={homeLogo ? homeLogo : logo}></img>
                <img 
                className="lang"
                src={langIcon}
                  alt="logo"
                onClick={toggleLanguage}></img>
            </div>
         
               <div className="bannerlp">
                    <img src={banners[0]?.img} className="imglp"
                    alt="banner"
                    />
                 </div>
                <div className="text">
                {lang === "en" ? "Please enter the PIN received to activate your subscription" : "الرجاء إدخال رقم التعريف الشخصي الذي استلمته لتفعيل اشتراكك"}
                </div>
                <div className='otp-container'>
            {otp?.map((data, index) => {
              return (
                <input
                  className={`otp-input ${isFilled(data) ? 'filled' : ''}`}
                  type="text"
                  name="otp"
                  maxLength="1"
                  key={index}
                  value={data}
                  onChange={e => handleChange(e.target, index)}
                  onFocus={e => e.target.select()}
                />
              )
            })}
          </div>
          {otpAtmptMsg &&  <p className="alert-text mt-1">{lang === "en" ? "Wrong OTP. ":"كلمة المرور لمرة واحدة خاطئة." } </p>}
          <p className="text-white text-lg mt-1">{count}/3 {lang === "en" ? "Attempts Left.":".محاولات اليسار" } </p>
          <div className="buttons">
                <button className="btn btn-primary" id="otp_submit_btn" disabled={!isOtpFilled}  onClick={()=>matchOtp()}>{lang === "en" ? "Confirm subscription" : "محفوظة. "}</button>
            <button className="btn btn-primary white"  onClick={goToSorry}> {lang === "en" ? "Exit" : "خروج"}</button>
            </div>
            
            <div className={`text white word-break ${lang === "ar" ? "rtl" : ""}`}>{lang === "en" ? "Free for 24 hours then" : "مجانا لمدة 24 ساعة من"} <span className="spantext">{lang === "en" ?"AED 2.10/ day" : "2.10 درهم إماراتي / يومياً "}</span> {lang === "en" ? "or" : "أو"} <span className="spantext">{lang === "en" ?"AED 11/ week " : "11 درهم إماراتي / أسبوعياً "}</span>{lang === "en" ? "(VAT inclusion)" : " (شامل ضريبة القيمة المضافة) "}</div>
            <Terms/>
            <Footer2 homeLogo={homeLogo}/>

        </div>
        }
        </>
    )
}

export default FillOtp